import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft, BookmarkSimple } from "@phosphor-icons/react";
import api, { fileUrl } from "../lib/api";

export default function Saves() {
  const nav = useNavigate();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/me/saves");
        setPosts(data || []);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-[100dvh] bg-ink pb-32" data-testid="saves-page">
      <div className="px-5 pt-6 flex items-center gap-3">
        <button onClick={() => nav(-1)} className="w-10 h-10 rounded-full crystal-glass flex items-center justify-center text-cream" data-testid="saves-back">
          <ArrowLeft size={18} />
        </button>
        <div>
          <p className="text-papaya text-[10px] tracking-[0.3em] uppercase font-bold">Saved</p>
          <h1 className="text-cream text-3xl font-black tracking-tighter">Your bookmarks</h1>
        </div>
      </div>

      {loading ? (
        <div className="px-5 mt-10 text-cream/40 text-xs tracking-[0.3em] uppercase animate-pulse">Loading…</div>
      ) : posts.length === 0 ? (
        <div className="mx-5 mt-10 rounded-3xl border border-dashed border-white/15 p-8 text-center" data-testid="saves-empty">
          <BookmarkSimple size={36} className="text-cream/30 mx-auto" weight="duotone" />
          <p className="text-cream font-bold mt-3">Nothing saved yet.</p>
          <p className="text-cream/50 text-xs mt-1">Tap the bookmark on any post to come back to it later.</p>
        </div>
      ) : (
        <div className="mt-6 grid grid-cols-3 gap-1 px-1">
          {posts.map((p) => (
            <Link
              key={p.id}
              to={`/p/${p.id}`}
              data-testid={`save-tile-${p.id}`}
              className="aspect-[3/4] bg-white/5 overflow-hidden relative"
            >
              {p.mux_playback_id ? (
                <img src={`https://image.mux.com/${p.mux_playback_id}/thumbnail.jpg?width=240`} alt="" className="w-full h-full object-cover" />
              ) : (
                <img src={p.media_path ? fileUrl(p.media_path) : ""} alt="" className="w-full h-full object-cover" />
              )}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
